/**
 * Provider for `cookies`
 * @module
 */

var _ = require('optimizely-client-fn');
var Cookie = require('core/utils/cookie');
var di = require('core/di');

var AudienceData = di.get('stores/audience_data');

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'cookies',

  isLazy: true,

  getter: [
    /**
     * @return {Object.<string>}
     *   Subset of defined cookies that are used by any audiences
     */
    function() {
      var allCookies = Cookie.getAll();
      var usedCookies = AudienceData.getFeaturesNeeded('cookies');
      return _.reduce(allCookies, function(res, cookieValue, cookieName) {
        if (_.has(usedCookies, cookieName)) {
          res[cookieName] = cookieValue;
        }
        return res;
      }, {});
    },
  ],
};
